interface PurchaseOrderStatusConfig {
  label: string;
  textColorClass: string;
}

export const getPurchaseOrderStatusConfig = (status: string, label?: string): PurchaseOrderStatusConfig => {
  const configs: Record<string, PurchaseOrderStatusConfig> = {
    draft: {
      label: label || 'Draft',
      textColorClass: 'text-muted-foreground',
    },
    sent: {
      label: label || 'Sent',
      textColorClass: 'text-blue-600 dark:text-blue-400',
    },
    accepted: {
      label: label || 'Accepted',
      textColorClass: 'text-green-600 dark:text-green-400',
    },
  };

  return configs[status] || { label: status, textColorClass: 'text-muted-foreground' };
};
